import React from 'react';
import IiscWorkshop2023 from 'views/IiscWorkshop2023';

const LifeSkillPage = () => {
  return <IiscWorkshop2023/>;
};

export default LifeSkillPage;
